import React from 'react';
import { pick } from 'ramda';

import { decamelize } from 'humps';
import attributes from './attribute-whitelist.json';

export const strippedBackElement = ({ element, className, children, elementRef, ...props }) => {
  if (!element) {
    return null;
  }

  if (typeof element === 'string') {
    const FormattedComponent = element;
    const whitelistedAttributes = {
      ...pick(attributes[element] || [], props),
      ...Object.keys(props)
        .filter(
          (propName) =>
            propName.substring(0, 4) === 'aria' || propName.substring(0, 4) === 'data' || propName === 'role' || propName === 'id'
        )
        .reduce((whitelistedProps, propName) => {
          // eslint-disable-next-line
          whitelistedProps[decamelize(propName, { separator: '-' })] = props[propName];

          return whitelistedProps;
        }, {})
    };

    return (
      <FormattedComponent className={className} ref={elementRef} {...whitelistedAttributes}>
        {children}
      </FormattedComponent>
    );
  }

  return React.cloneElement(element, {
    className,
    children
  });
};

export default strippedBackElement;
